import { Button, Col, Form, InputNumber, message, Row, Space, Spin } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { ButtonFooter } from '../../WorkPage/PopupWorkForm/PopupWorkFormStyled'

const AssetInputUpdate = props => {
  const { onClose, onCancel } = props
  const [form] = Form.useForm()
  const { managementAssetWarehouseStore, assetHistory } = props
  const [isLoading, setIsLoading] = useState(false)
  const [changeTax, setChangeTax] = useState(0)
  const [changePrice, setChangePrice] = useState(0)

  useEffect(() => {
    const taxMoney = assetHistory?.total_money - assetHistory?.pre_money
    form.setFieldsValue({
      quantity: assetHistory?.quantity,
      asset_name: assetHistory?.asset_name,
      asset_type_id: assetHistory?.asset_type?.id,
      asset_unit_name: assetHistory?.asset_unit_name,
      property: assetHistory?.property,
      tax: assetHistory?.tax,
      price: assetHistory?.price,
      pre_money: assetHistory?.pre_money,
      tax_money: taxMoney,
      total_money: assetHistory?.total_money,
    })

    setChangeTax(Number(assetHistory?.tax))
    setChangePrice(Number(assetHistory?.price))
  }, [assetHistory])
  useEffect(() => {
    calSum()
  }, [changeTax, changePrice])

  const calSum = () => {
    const pre_money = (assetHistory?.quantity * changePrice).toFixed(0)
    const taxMoney = (
      (assetHistory?.quantity * changePrice * Number(assetHistory?.tax)) /
      100
    ).toFixed(0)
    const total_money = Number(pre_money) + Number(taxMoney)
    form.setFieldsValue({
      pre_money: pre_money,
    })
    form.setFieldsValue({
      tax_money: taxMoney,
    })
    form.setFieldsValue({
      total_money: total_money,
    })
  }

  const onFinish = async value => {
    setIsLoading(true)
    const assetHistoryData = {
      asset_id: assetHistory?.asset_id,
      tax: value.tax,
      price: value.price,
      preMoney: Number(value.pre_money),
      totalMoney: Number(value.total_money),
      quantity: value.quantity,
    }

    managementAssetWarehouseStore
      .updateAssetHistory(assetHistory?.id, assetHistoryData)
      .then(() => {
        message.success('Chỉnh sửa tài sản thành công')
        onClose()
      })
      .catch(error => {
        console.log(error)
        message.error('Chỉnh sửa tài sản thất bại!!')
        props.onCancel()
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <>
      <Form onFinish={onFinish} form={form} layout="vertical">
        <Spin spinning={isLoading}>
          <Row gutter={[16, 16]}>
            Tên văn phòng phẩm: {assetHistory?.assetName}
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label={'Đơn giá trước thuế:'}
                name={'price'}
                validateStatus="success">
                <InputNumber
                  className="h-40"
                  onChange={value => setChangePrice(value)}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  precision={2}
                  style={{
                    width: '100%',
                  }}
                  min={0}
                  placeholder={'Nhập đơn giá trước thuế'}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={'Số lượng nhập kho:'}
                name={'quantity'}
                validateStatus="success">
                <InputNumber
                  className="h-40"
                  style={{
                    width: '100%',
                  }}
                  placeholder={'Nhập số lượng'}
                  onChange={value => {
                    if (value) {
                      form.setFieldsValue({ quantity: value })
                    }
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label={'Thuế (%):'}
                name={'tax'}
                validateStatus="success">
                <InputNumber
                  style={{ width: '100%' }}
                  min={0}
                  className="h-40"
                  placeholder={'Nhập thuế'}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={'Thuế suất'}
                name={'tax_money'}
                validateStatus="success">
                <InputNumber
                  style={{ width: '100%' }}
                  min={0}
                  className="h-40"
                  placeholder={'Thuế suất'}
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                label={'Tổng giá trước thuế:'}
                name={'pre_money'}
                validateStatus="success">
                <InputNumber
                  className="h-40"
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  style={{
                    width: '100%',
                  }}
                  min={0}
                  placeholder={'Tổng giá trước thuế'}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={'Tổng giá sau thuế:'}
                name={'total_money'}
                validateStatus="success">
                <InputNumber
                  className="h-40"
                  formatter={value =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  }
                  style={{
                    width: '100%',
                  }}
                  min={0}
                  placeholder={'Tổng giá sau thuế'}
                />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
        <ButtonFooter>
          <Space>
            <Button className="custom-ant-button" danger onClick={onCancel}>
              Đóng
            </Button>
            <Button className="custom-ant-button" onClick={calSum}>
              Tổng
            </Button>
            <Button
              className="custom-ant-button"
              type={'primary'}
              htmlType={'submit'}
              loading={isLoading}>
              Lưu
            </Button>
          </Space>
        </ButtonFooter>
      </Form>
    </>
  )
}
export default inject(
  'managementAssetWarehouseStore',
  'selectPeopleStore'
)(observer(AssetInputUpdate))
